import { atom } from 'recoil';

const groupHostInfo = atom<{ name: string; note: string }>({
  key: 'groupHostInfo',
  default: {
    name: '',
    note: '',
  },
});

export default groupHostInfo;
